"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TerraformingContract = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var TerraformingContract = (function (_super) {
    __extends(TerraformingContract, _super);
    function TerraformingContract() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.TERRAFORMING_CONTRACT,
            cost: 8,
            tags: [Tags_1.Tags.EARTH],
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.tr(25); }),
            metadata: {
                cardNumber: '252',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.megacredits(4); });
                }),
                description: 'Requires that you have at least 25 TR. Increase your M€ production 4 steps.',
            },
        }) || this;
    }
    TerraformingContract.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 4);
        return undefined;
    };
    return TerraformingContract;
}(Card_1.Card));
exports.TerraformingContract = TerraformingContract;
//# sourceMappingURL=TerraformingContract.js.map